import React from 'react';

import { SKELETON_TOKENS, SkeletonBlock, SkeletonOverlay } from 'components/shared';

const SECTION_COUNT = 3;
const DISH_COUNT = 4;

// Mirrors MenuSectionManagement/styles.tsx: 37px section bar, wrapping AccordionDetails
// and dishPreviewItemRoot (345×185 card with a 9px colour strip).
const row: React.CSSProperties = { display: 'flex', alignItems: 'center' };
const grid: React.CSSProperties = { display: 'flex', flexWrap: 'wrap', padding: '8px 0 16px' };
const card: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    width: 345,
    height: 185,
    margin: '15px 5px 33px 5px',
    boxSizing: 'border-box',
    overflow: 'hidden',
    border: `1px solid ${SKELETON_TOKENS.divider}`,
    borderRadius: SKELETON_TOKENS.radius,
};
const cardFooter: React.CSSProperties = {
    ...row,
    justifyContent: 'space-between',
    padding: '0 16px',
    flexGrow: 1,
};

export default function MenuDetailsSkeleton({ isLoading }: { isLoading: boolean }) {
    return (
        <SkeletonOverlay isLoading={isLoading} style={{ top: 60 }}>
            <div
                style={{
                    ...row,
                    gap: 12,
                    height: 64,
                    flexShrink: 0,
                    padding: '0 16px',
                    marginBottom: 10,
                }}
            >
                <SkeletonBlock height={24} width={24} />
                <SkeletonBlock height={24} width={240} />
                <div style={{ flexGrow: 1 }} />
                <SkeletonBlock height={16} width={60} />
                <SkeletonBlock height={24} width={24} />
            </div>
            {Array.from({ length: SECTION_COUNT }, (_, section) => (
                <React.Fragment key={section}>
                    <SkeletonBlock height={37} style={{ borderRadius: 0 }} />
                    <div style={grid}>
                        {Array.from({ length: DISH_COUNT }, (_, dish) => (
                            <div key={dish} style={card}>
                                <div style={{ ...row, gap: 16, padding: 16 }}>
                                    <SkeletonBlock
                                        height={40}
                                        width={40}
                                        style={{ borderRadius: '50%' }}
                                    />
                                    <div style={{ flexGrow: 1 }}>
                                        <SkeletonBlock height={20} width={150} />
                                        <SkeletonBlock
                                            height={14}
                                            width={60}
                                            style={{ marginTop: 6 }}
                                        />
                                    </div>
                                    <SkeletonBlock height={24} width={24} />
                                </div>
                                <SkeletonBlock
                                    height={14}
                                    width={260}
                                    style={{ margin: '0 16px' }}
                                />
                                <div style={cardFooter}>
                                    <SkeletonBlock height={16} width={60} />
                                    <SkeletonBlock height={24} width={80} />
                                </div>
                                <SkeletonBlock height={9} style={{ borderRadius: 0 }} />
                            </div>
                        ))}
                    </div>
                </React.Fragment>
            ))}
        </SkeletonOverlay>
    );
}
